import styled, { css } from 'styled-components'

// prettier-ignore
/** @param {{ inactive?: boolean }} props */
const inactiveStyles = props => props.inactive && css`
  opacity: 0.5;

  cursor: default;
  pointer-events: none;
`

const ButtonBase = styled.div`
  display: grid;
  place-items: center;

  color: #333333;
  font-family: 'Gotham-Medium';
  font-size: 13px;
  line-height: 31px;

  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #e6e6e6;

  user-select: none;
  cursor: pointer;

  ${inactiveStyles}
`

export default ButtonBase



// WEBPACK FOOTER //
// ./src/lib/components/ButtonBase.jsx